import m from './1.0.1/index.vue'

export default m;
